// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/customer_contract_csv_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { ContractStage, KwPeriod, PrivateGeneration } from "./customer_model_pb";
import { file_bffuser_v1_customer_model } from "./customer_model_pb";
import type { VoltageClass } from "./occto_master_model_pb";
import { file_bffuser_v1_occto_master_model } from "./occto_master_model_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/customer_contract_csv_model.proto.
 */
export const file_bffuser_v1_customer_contract_csv_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bffuser_v1_customer_model, file_bffuser_v1_occto_master_model, file_google_type_date, file_google_type_decimal]);

/**
 * ImportCustomerContractsRowResult は差分プレビューの 1 行。値は取込後の値。
 * internalapi.v1.ImportCustomerContractsRowResult と field 番号を一致させる。
 *
 * @generated from message bffuser.v1.ImportCustomerContractsRowResult
 */
export type ImportCustomerContractsRowResult = Message<"bffuser.v1.ImportCustomerContractsRowResult"> & {
  /**
   * @generated from field: int32 row_number = 1;
   */
  rowNumber: number;

  /**
   * @generated from field: bffuser.v1.ImportCustomerContractsRowStatus status = 2;
   */
  status: ImportCustomerContractsRowStatus;

  /**
   * @generated from field: optional string customer_supply_point_id = 3;
   */
  customerSupplyPointId?: string;

  /**
   * @generated from field: bffuser.v1.ContractStage contract_stage = 4;
   */
  contractStage: ContractStage;

  /**
   * @generated from field: optional bffuser.v1.ContractStage previous_contract_stage = 5;
   */
  previousContractStage?: ContractStage;

  /**
   * @generated from field: string customer_name = 6;
   */
  customerName: string;

  /**
   * @generated from field: bool is_new_customer = 7;
   */
  isNewCustomer: boolean;

  /**
   * @generated from field: optional string contractor_name = 8;
   */
  contractorName?: string;

  /**
   * @generated from field: bool is_new_contractor = 9;
   */
  isNewContractor: boolean;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 10;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bffuser.v1.VoltageClass voltage_class = 11;
   */
  voltageClass: VoltageClass;

  /**
   * @generated from field: optional string supply_point_specific_number = 12;
   */
  supplyPointSpecificNumber?: string;

  /**
   * @generated from field: optional google.type.Decimal contract_kw = 13;
   */
  contractKw?: Decimal;

  /**
   * @generated from field: optional google.type.Date supply_start_date = 14;
   */
  supplyStartDate?: Date;

  /**
   * @generated from field: optional google.type.Date supply_end_date = 15;
   */
  supplyEndDate?: Date;

  /**
   * @generated from field: optional string retailer_business_code = 16;
   */
  retailerBusinessCode?: string;

  /**
   * @generated from field: bffuser.v1.PrivateGeneration private_generation = 17;
   */
  privateGeneration?: PrivateGeneration;

  /**
   * 以下は変更の行だけ: 取込前の値。
   *
   * @generated from field: optional google.type.Decimal existing_contract_kw = 18;
   */
  existingContractKw?: Decimal;

  /**
   * @generated from field: optional string existing_supply_point_specific_number = 19;
   */
  existingSupplyPointSpecificNumber?: string;

  /**
   * @generated from field: optional google.type.Date existing_supply_start_date = 20;
   */
  existingSupplyStartDate?: Date;

  /**
   * @generated from field: optional google.type.Date existing_supply_end_date = 21;
   */
  existingSupplyEndDate?: Date;

  /**
   * @generated from field: optional string existing_retailer_business_code = 22;
   */
  existingRetailerBusinessCode?: string;

  /**
   * @generated from field: optional bffuser.v1.PrivateGeneration existing_private_generation = 23;
   */
  existingPrivateGeneration?: PrivateGeneration;

  /**
   * @generated from field: optional string existing_customer_name = 25;
   */
  existingCustomerName?: string;

  /**
   * @generated from field: optional string existing_contractor_name = 26;
   */
  existingContractorName?: string;

  /**
   * @generated from field: optional bfftypes.v1.AreaCode existing_area_code = 27;
   */
  existingAreaCode?: AreaCode;

  /**
   * @generated from field: optional bffuser.v1.VoltageClass existing_voltage_class = 28;
   */
  existingVoltageClass?: VoltageClass;

  /**
   * 取込後の契約電力の期間 (最初の期間の後のもの。最初の期間は contract_kw と supply_start_date)。
   * ファイルに契約電力の変更の列が無い行は登録済みの期間をそのまま載せる。
   *
   * @generated from field: repeated bffuser.v1.KwPeriod kw_periods = 29;
   */
  kwPeriods: KwPeriod[];

  /**
   * 変更の行の、取込前の期間 (最初の期間の後のもの)。
   *
   * @generated from field: repeated bffuser.v1.KwPeriod existing_kw_periods = 30;
   */
  existingKwPeriods: KwPeriod[];

  /**
   * エラー行の文言。「行 N: 」は frontend が行番号から前置する。
   *
   * @generated from field: repeated string error_messages = 24;
   */
  errorMessages: string[];
};

/**
 * Describes the message bffuser.v1.ImportCustomerContractsRowResult.
 * Use `create(ImportCustomerContractsRowResultSchema)` to create a new message.
 */
export const ImportCustomerContractsRowResultSchema: GenMessage<ImportCustomerContractsRowResult> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_contract_csv_model, 0);

/**
 * ImportCustomerContractsSummary は件数の集計。
 *
 * @generated from message bffuser.v1.ImportCustomerContractsSummary
 */
export type ImportCustomerContractsSummary = Message<"bffuser.v1.ImportCustomerContractsSummary"> & {
  /**
   * @generated from field: int32 new_row_count = 1;
   */
  newRowCount: number;

  /**
   * @generated from field: int32 changed_row_count = 2;
   */
  changedRowCount: number;

  /**
   * @generated from field: int32 unchanged_row_count = 3;
   */
  unchangedRowCount: number;

  /**
   * @generated from field: int32 error_row_count = 4;
   */
  errorRowCount: number;

  /**
   * @generated from field: int32 total_row_count = 5;
   */
  totalRowCount: number;

  /**
   * 変更の行のうち、区分が 見込み → 契約 に変わる行数 (changed_row_count に含む)。
   *
   * @generated from field: int32 stage_change_row_count = 6;
   */
  stageChangeRowCount: number;
};

/**
 * Describes the message bffuser.v1.ImportCustomerContractsSummary.
 * Use `create(ImportCustomerContractsSummarySchema)` to create a new message.
 */
export const ImportCustomerContractsSummarySchema: GenMessage<ImportCustomerContractsSummary> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_contract_csv_model, 1);

/**
 * ExportCustomerContractsRow は登録済みデータのダウンロード 1 行 (1 地点 1 行)。
 *
 * @generated from message bffuser.v1.ExportCustomerContractsRow
 */
export type ExportCustomerContractsRow = Message<"bffuser.v1.ExportCustomerContractsRow"> & {
  /**
   * @generated from field: string customer_supply_point_id = 1;
   */
  customerSupplyPointId: string;

  /**
   * @generated from field: string customer_id = 2;
   */
  customerId: string;

  /**
   * @generated from field: bffuser.v1.ContractStage contract_stage = 3;
   */
  contractStage: ContractStage;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 4;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: string customer_name = 5;
   */
  customerName: string;

  /**
   * @generated from field: optional string supply_point_specific_number = 6;
   */
  supplyPointSpecificNumber?: string;

  /**
   * @generated from field: bffuser.v1.VoltageClass voltage_class = 7;
   */
  voltageClass: VoltageClass;

  /**
   * @generated from field: google.type.Decimal contract_kw = 8;
   */
  contractKw?: Decimal;

  /**
   * @generated from field: google.type.Date supply_start_date = 9;
   */
  supplyStartDate?: Date;

  /**
   * @generated from field: optional google.type.Date supply_end_date = 10;
   */
  supplyEndDate?: Date;

  /**
   * @generated from field: optional string retailer_business_code = 11;
   */
  retailerBusinessCode?: string;

  /**
   * @generated from field: bffuser.v1.PrivateGeneration private_generation = 12;
   */
  privateGeneration?: PrivateGeneration;

  /**
   * @generated from field: string contractor_id = 13;
   */
  contractorId: string;

  /**
   * @generated from field: string contractor_name = 14;
   */
  contractorName: string;

  /**
   * 契約電力の期間 (最初の期間の後のもの。最初の期間は contract_kw と supply_start_date)。
   *
   * @generated from field: repeated bffuser.v1.KwPeriod kw_periods = 15;
   */
  kwPeriods: KwPeriod[];
};

/**
 * Describes the message bffuser.v1.ExportCustomerContractsRow.
 * Use `create(ExportCustomerContractsRowSchema)` to create a new message.
 */
export const ExportCustomerContractsRowSchema: GenMessage<ExportCustomerContractsRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_contract_csv_model, 2);

/**
 * ImportCustomerContractsRowStatus は顧客契約 CSV 1 行の差分判定結果。
 * internalapi.v1.ImportCustomerContractsRowStatus と値名・番号を一致させる。
 *
 * @generated from enum bffuser.v1.ImportCustomerContractsRowStatus
 */
export enum ImportCustomerContractsRowStatus {
  /**
   * @generated from enum value: IMPORT_CUSTOMER_CONTRACTS_ROW_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: IMPORT_CUSTOMER_CONTRACTS_ROW_STATUS_NEW = 1;
   */
  NEW = 1,

  /**
   * @generated from enum value: IMPORT_CUSTOMER_CONTRACTS_ROW_STATUS_CHANGED = 2;
   */
  CHANGED = 2,

  /**
   * @generated from enum value: IMPORT_CUSTOMER_CONTRACTS_ROW_STATUS_UNCHANGED = 3;
   */
  UNCHANGED = 3,

  /**
   * @generated from enum value: IMPORT_CUSTOMER_CONTRACTS_ROW_STATUS_ERROR = 4;
   */
  ERROR = 4,
}

/**
 * Describes the enum bffuser.v1.ImportCustomerContractsRowStatus.
 */
export const ImportCustomerContractsRowStatusSchema: GenEnum<ImportCustomerContractsRowStatus> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_customer_contract_csv_model, 0);

